<template>
    <div>
        <el-dialog title="编辑" :close-on-click-modal="false" :visible.sync="editFormVisible"  > 
            <newTranslog 
                :TransLog_Edit="CurrentTransLog" 
                :fileList2="CurrentTransLogImages" 
                :isNew='false'
                :showcontinue='false'
                id='editForm' ></newTranslog>
        </el-dialog>
        <!-- <el-card> -->
            <el-row :gutter="5">
                <el-col :span="4">
                    <el-select v-model="searchview.CustomerId" placeholder="客户" clearable filterable multiple style="width: 100%">
                        <el-option v-for="customer in customers" :key="customer.Id" :value="customer.Id" :label="customer.Desc"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-date-picker  v-model="searchview.DeveliverDtFrom"  type="date" style="width: 100%" placeholder="发货日期从" width="80px"></el-date-picker>
                </el-col>
                <el-col :span="3">
                    <el-date-picker  v-model="searchview.DeveliverDtTo"  type="date" style="width: 100%" placeholder="发货日期到"></el-date-picker>
                </el-col>
                <el-col :span="3"><el-input v-model="searchview.Destination" placeholder="到站"  style="width:100%"></el-input></el-col>
                <el-col :span="3"><el-input v-model="searchview.BillNo" style="width:100%" placeholder="运单号"></el-input></el-col>
                <el-col :span="3">
                    <el-select v-model="searchview.ReceiptStatus" placeholder="回单状态" clearable filterable>
                        <el-option v-for="rstatus in rstatusitems" :key="rstatus.Id" :value="rstatus.Id" :label="rstatus.Text">{{rstatus.Text}}</el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                     <el-autocomplete class="inline-input" v-model="searchview.Carrier"  :fetch-suggestions="querySearchC"  placeholder="承运商" 
                        :trigger-on-focus="true" @select="handleSelectC" style="width:100%">
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.Desc }}</div>
                        </template>
                    </el-autocomplete>
                </el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="3"><el-input v-model="searchview.BillNo3" placeholder="采购单号"></el-input></el-col>
                <el-col :span="3"><el-input v-model="searchview.ProCode" placeholder="商品编码"></el-input></el-col>
                <el-col :span="3"><el-input v-model="searchview.ProName" placeholder="商品名称"></el-input></el-col>
                <el-col :span="3">
                    <el-select v-model="searchview.Reason" placeholder="异常原因" clearable filterable>
                        <el-option v-for="item in reasons" :key="item.Id" :label="item.Desc" :value="item.Id" >{{item.Desc}}</el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-select v-model="searchview.BackRemark" placeholder="退货处理状态" clearable filterable>
                        <el-option v-for="item in BackRemarkItems" :key="item.Id" :label="item.Desc" :value="item.Id">{{item.Desc}}</el-option>
                    </el-select>
                </el-col>
                <el-col :span="3"><el-input v-model="searchview.BillNo2" style="width:100%" placeholder="代单号"></el-input></el-col>
                <el-col :span="2">
                    <el-select v-model="searchview.GoodsStatus" placeholder="状态" clearable filterable> 
                        <el-option v-for="status in statusItems" :key="status.Id" :label="status.Text" :value="status.Text"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="5">
                
                <el-col :span="3">
                  <el-date-picker  v-model="searchview.StoreDtFrom"  type="date" style="width: 100%" placeholder="入仓日期从"></el-date-picker>
              </el-col>
              <el-col :span="3">
                  <el-date-picker  v-model="searchview.StoreDtTo"  type="date" style="width: 100%" placeholder="入仓日期到"></el-date-picker>
              </el-col>
              <el-col :span="2"><el-button type="primary" @click="handlesearch" style="width:100%;" icon="el-icon-search">查询</el-button></el-col>
              <el-col :span="2"><el-button type="primary" size="mini" @click="handleFullScreen" style="width:100%;" icon="el-icon-rank">全屏</el-button></el-col>
            
            </el-row>
        <!-- </el-card> -->
   
        <!-- <div id="content"  style="width: 100%;height:100%;overflow:auto;" > -->
        <el-table  id="content"
            :data="TransLogs"   
            @row-dblclick="handleEdit" 
            :loading="searching"
            :row-style="tableRowStyle" 
            @sort-change="changeTableSort" 
            :height="tableHeight"
            header-cell-style="background-color: #f2f2f2;color:#707070;font-weight: normal; background-image: linear-gradient(to bottom,#f8f8f8 0,#ececec 100%);
    background-repeat: repeat-x;"
            >
            <el-table-column type="expand" width="40" >
                <template slot-scope="props">
                    异常信息
                    <el-table :data="props.row.TransLogExps" style="width: 800px;" border >
                        <el-table-column type="index"  width="50"></el-table-column>
                      <el-table-column label="采购单号" prop="BillNo"></el-table-column>
                      <el-table-column label="商品编码" prop="ProCode"></el-table-column>
                      <el-table-column label="商品名称" prop="ProName"></el-table-column>
                      <el-table-column label="差异数量" prop="DiffCount"></el-table-column>
                      <el-table-column label="异常原因" prop="ReasonDesc"></el-table-column>
                      <el-table-column label="跟踪处理情况" prop="ProcessRemarkDesc"></el-table-column>
                      <el-table-column label="退货处理状态" prop="BackRemarkDesc"></el-table-column>
                    </el-table>
                    签收照片
                    <!-- <div v-for="image in props.row.TransLogImages" :key="image.Id">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="image.FileGuid"/>
                                <img slot="reference" :src="image.FileGuid" :alt="image.FileName" style="max-height: 50px;max-width: 130px">
                               </el-popover>

                            <el-link :src="image.FileGuid" target="_blank">{{image.FileName}}</el-link>
                        </div> -->
                        <div>
                         <viewer :images="props.row.TransLogImages">
                            <img v-for="image in props.row.TransLogImages" :src="image.FileGuid" :key="image.Id" style="max-height: 50px;max-width: 130px">
                        </viewer>
                        </div>
                      </template>
                </el-table-column>
            <el-table-column label="" fixed width="40"> 
                <template slot-scope="scope">
                    <i class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>   
            <el-table-column prop="CustomerName" label="客户"  width="60"></el-table-column>
            <el-table-column prop="DeveliverDt" label="发货日期"  width="100" :formatter="formatterController" sortable="custom"></el-table-column>
            <el-table-column prop="Destination" label="到站"  width="50"></el-table-column>
            <el-table-column prop="StoreDt" label="入仓日期"  width="100" :formatter="formatterController" sortable="custom"></el-table-column>
            <el-table-column prop="Receiver" label="收货人"  width="60"></el-table-column>
            <el-table-column prop="GoodsStatus" label="状态"  width="60" align="right"></el-table-column>
            <el-table-column prop="Comment" label="跟进结果"  width="180"></el-table-column>
            <el-table-column prop="Remarks" label="备注"  width="180"></el-table-column>
            <el-table-column prop="CarrierName" label="承运商"  width="60"></el-table-column>
            <el-table-column prop="BillNo" label="运单号"  width="100"></el-table-column>
            <el-table-column prop="BillNo2" label="代单号"  width="120"></el-table-column>
            <el-table-column prop="GoodsCount" label="件数"  width="80" align="right"></el-table-column>
            
            <el-table-column prop="ReceiverPhone" label="收货人电话"  width="100"></el-table-column>

             <el-table-column label="货物信息" align="center">
                <el-table-column prop="GoodsCube" label="体积"  width="80" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="GoodsWeight" label="重量"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="Terminalinventory" label="末端库存"  width="100" align="right"></el-table-column>
             </el-table-column>

            <el-table-column label="C费用" align="center">
                <el-table-column prop="CFeeBasic" label="C基本费用"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="CFeePickup" label="C提货费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="CFeeDeliver" label="C运输费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="CFeeOp" label="C操作费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="CFeePackage" label="C包装费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="CFeeTotal" label="C费合计"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
            </el-table-column>

            <el-table-column label="费用" align="center">
                <el-table-column prop="FeeBasic" label="基本费用"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeePickup" label="提货费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeeDeliver" label="运输费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeeOp" label="操作费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeePackage" label="包装费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeeGoodsPrice" label="货物价值"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeeInsu" label="保险"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
                <el-table-column prop="FeeTotal" label="费用合计"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
            </el-table-column>

            <el-table-column prop="ReceiptStatusDesc" label="回单状态"  width="80" align="center"></el-table-column>
            <el-table-column prop="ReceiverAddress" label="收货人地址"  width="180"></el-table-column>
            <el-table-column prop="CFeeBack" label="C退货费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
            <el-table-column prop="FeeBack" label="退货费"  width="100" align="right" :formatter="formatterDecimal"></el-table-column>
        </el-table>
        <el-col  :span="24">
            <el-pagination small
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="recordtotal">
            </el-pagination>
        </el-col>
        <!-- </div> -->
    </div>
    
</template>

<script>
    import MaintainTransLogJs from "./MaintainTransLog_Sales.js";
    export default MaintainTransLogJs;

</script>

<style scoped>
     .el-row {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }

.r{
    position:fixed; 
    bottom:0;
    background-color: rgb(162, 247, 228);
    width:100%;
    margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/MaintainTransLog_Sales/MaintainTransLog_Sales.vue